export const BASE_URL = 'https://mykinderguide.ru/api/v1/';

export const EMAIL_PATTERN = '[a-zA-Z0-9_.]+@[a-zA-Z0-9_]+\\.[a-z]{2,}';
